module.exports = __webpack_public_path__ + "static/desktop/img/Paypal-tip.41779548.png";